xplenty.directive('componentEditorTransformation', [
  '$compile',

  function ($compile) {
    return {
      controller: 'ComponentEditorTransformationController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-transformation.html'),

      replace: true,

      link(scope, element) {
        element.append($compile(scope.component.editorDirective)(scope));
      },
    };
  },
]);
